import { BaseInvitePeopleAnalytics } from '../../analytics';
import type { CollectionGroupType } from '../../experiments/twcForCoreInvites/getGroupedProductOptions';
import { AnalyticsAction, AnalyticsActionSubject, type ProductSelectOption } from '../../types';

export class ProductSelectAnalytics extends BaseInvitePeopleAnalytics {
	productSelectRendered(productOptions: ProductSelectOption[]) {
		const { userRole, source } = this.commonAttributes;

		this.fireUI({
			actionSubject: AnalyticsActionSubject.DROPDOWN,
			actionSubjectId: 'customizedProductSelect',
			action: AnalyticsAction.RENDERED,
			attributes: {
				integration: source,
				source,
				userRole,
				productOptions,
			},
		});
	}

	selectAllClicked(productsSelected: string[]) {
		const { productTitle, source, userRole } = this.commonAttributes;

		this.fireUI({
			actionSubject: AnalyticsActionSubject.DROPDOWN_ITEM,
			action: AnalyticsAction.CLICKED,
			actionSubjectId: 'selectAll',
			attributes: {
				integration: source,
				source,
				product: productTitle.toLowerCase(),
				productsSelected,
				permissionLevel: userRole,
			},
		});
	}

	getAvailableProductsSucceeded(resourceAri: string, availableResourcesAri: string[]) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.INVITE_CAPABILITIES,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.SUCCEEDED,
			attributes: {
				availableResourcesAri,
			},
		});
	}

	getAvailableProductsFailed(resourceAri: string) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.INVITE_CAPABILITIES,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.FAILED,
		});
	}

	getCollectionsSucceeded(resourceAri: string, hasTeamworkCollection: boolean) {
		const { productTitle, source, subProduct, jiraSubProduct, userRole } = this.commonAttributes;
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.GET_COLLECTIONS,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.SUCCEEDED,
			attributes: {
				hasTeamworkCollection,
				productTitle,
				source,
				subProduct,
				jiraSubProduct,
				userRole,
			},
		});
	}

	getCollectionsFailed(resourceAri: string) {
		const { productTitle, source, subProduct, jiraSubProduct, userRole } = this.commonAttributes;
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.GET_COLLECTIONS,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.FAILED,
			attributes: { productTitle, source, subProduct, jiraSubProduct, userRole },
		});
	}

	groupsRendered(
		productsSelected: string[],
		options: (ProductSelectOption | CollectionGroupType<ProductSelectOption>)[],
	) {
		const { productTitle, source, subProduct, jiraSubProduct, userRole } = this.commonAttributes;
		this.fireUI({
			actionSubject: AnalyticsActionSubject.DROPDOWN,
			actionSubjectId: 'twcForCoreInvites',
			action: AnalyticsAction.RENDERED,
			attributes: {
				productsSelected,
				productTitle,
				source,
				subProduct,
				jiraSubProduct,
				userRole,
				options,
			},
		});
	}
}
